import { render, staticRenderFns } from "./FlightDetail.vue?vue&type=template&id=4cf3cf6a&scoped=true"
import script from "./FlightDetail.vue?vue&type=script&lang=js"
export * from "./FlightDetail.vue?vue&type=script&lang=js"
import style0 from "./FlightDetail.vue?vue&type=style&index=0&id=4cf3cf6a&prod&lang=css"
import style1 from "./FlightDetail.vue?vue&type=style&index=1&id=4cf3cf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3cf6a",
  null
  
)

export default component.exports